import posthog from 'posthog-js';
import { isHandGestureSupported } from '../utils/feature-detection';

export function useHandGestureFeatureFlag(): boolean {
  // PostHog feature flag gates remote kill-switch. Default to enabled (true)
  // when PostHog hasn't loaded or the flag doesn't exist yet — the flag acts
  // as a remote OFF switch, not an ON switch. This ensures the button appears
  // without requiring a PostHog dashboard action to create the flag first.
  const flagValue = posthog.isFeatureEnabled('hand-gesture-controls');
  const flagEnabled = flagValue === undefined ? true : Boolean(flagValue);
  const browserSupported = isHandGestureSupported();
  return flagEnabled && browserSupported;
}
